import React, { useState } from "react";
import Auth from "@aws-amplify/auth";
import GenericInput from "../containers/helpers/genericInput";
import { useFormFields } from "../libs/hooksLibs";
import style from "../styles/LoginInput.module.scss";
import styles from "../styles/SignIn.module.scss";
import buttonStyle from "../styles/LoaderButton.module.scss";
import classnames from "classnames";

export default function ForgotPassword({ fromBBClient, passwordReset }) {
  const [showPasswordReset, setShowPasswordReset] = useState(false);
  const [passwordCodeMesssage, setPasswordCodeMessage] = useState("");
  const [passwordResetError, setPasswordResetError] = useState("");

  const [fields, handleFieldChange] = useFormFields({
    username: "",
    code: "",
    password: "",
    confirmPassword: "",
  });

  const inputStyles = {
    container: style.loginContainer,
    label: style.loginInputLabel,
    input: style.loginInput,
  };

  const loaderButtonClass = classnames({
    [buttonStyle.LoaderButton]: true,
    [buttonStyle.client]: true,
  });

  function setMessage(delivery, destination) {
    switch (delivery) {
      case "SMS":
        return `We have sent a password reset code by sms to ${destination}. \n Enter it below to reset your password.`;
      case "EMAIL":
        return `We have sent a password reset code by email to ${destination}. \n Enter it below to reset your password`;
      default:
        return `Enter the code sent to ${destination} to reset your password.`;
    }
  }

  function requestCode() {
    if (!fields.username) {
      setPasswordResetError("Username must not be empty.");
    }
    Auth.forgotPassword(fields.username)
      .then((data) => {
        const { DeliveryMedium, Destination } = data.CodeDeliveryDetails;
        setPasswordCodeMessage(setMessage(DeliveryMedium, Destination));
        setShowPasswordReset(true);
      })
      .catch((err) => {
        setPasswordResetError(err.message);
      });
  }

  function resetPassword() {
    if (fields.password && fields.confirmPassword) {
      if (fields.password === fields.confirmPassword) {
        Auth.forgotPasswordSubmit(fields.username, fields.code, fields.password)
          .then((data) => {
            // take user back to sign in page
            passwordReset(false);
          })
          .catch((err) => {
            setPasswordResetError(err.message);
          });
      } else {
        setPasswordResetError("Error: Passwords do not match.");
      }
    } else {
      setPasswordResetError("Error: Passwords cannot be empty.");
    }
  }

  function showSignIn() {
    passwordReset(false);
  }

  return (
    <>
      {passwordResetError && (
        <div className={styles.forgotPasswordErrorClient}>
          {passwordResetError}
        </div>
      )}
      {showPasswordReset ? (
        <>
          <div className={styles.clientDefaultText}>{passwordCodeMesssage}</div>
          <GenericInput
            type={"text"}
            placeholder={"Code"}
            inputName={"code"}
            inputValue={fields.code}
            changeCallback={handleFieldChange}
            styles={inputStyles}
          />
          <div className={styles.forgotPasswordDescContainerClient}>
            <GenericInput
              type={"password"}
              placeholder={"Password"}
              inputName={"password"}
              inputValue={fields.password}
              changeCallback={handleFieldChange}
              styles={inputStyles}
            />
            <div className={styles.forgotPasswordDescClient}>
              {" "}
              Passwords must be at least 8 characters long and contain at least
              one number
            </div>
          </div>

          <GenericInput
            type={"password"}
            placeholder={"Confirm Password"}
            inputName={"confirmPassword"}
            inputValue={fields.confirmPassword}
            changeCallback={handleFieldChange}
            styles={inputStyles}
          />

          <span className={styles.returnToSignInLink} onClick={showSignIn}>
            Return to Sign in
          </span>
          <button
            className={loaderButtonClass}
            onClick={resetPassword}
            type="submit"
            style={{ marginTop: "10px" }}
          >
            <span>Change Password</span>
          </button>
        </>
      ) : (
        <>
          <div className={styles.clientDefaultText}>
            {" "}
            Enter your username below and we will email you a code to reset your
            password.
          </div>
          <GenericInput
            type={"text"}
            placeholder={"Username"}
            inputName={"username"}
            inputValue={fields.username}
            changeCallback={handleFieldChange}
            styles={inputStyles}
          />
          <span className={styles.returnToSignInLink} onClick={showSignIn}>
            Return to Sign in
          </span>
          <button
            className={styles.resetPasswordBtnClient}
            onClick={requestCode}
            type="submit"
          >
            Request Password Reset Code
          </button>
        </>
      )}
    </>
  );
}
